export const NO_CHANGES_REASON = "No changes were made";
export const INVALID_FORM_REASON = "Some required fields are empty or invalid";
